/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Highlights_Muscles_LabelInputs */

const en_us2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map of the muscles this workout worked`)
};

const pt_br2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos que este treino trabalhou`)
};

const es_419_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de los músculos que trabajó este entrenamiento`)
};

const pt_pt2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos que este treino trabalhou`)
};

const fr_fr2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte des muscles travaillés pendant cette séance`)
};

const de_de2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte der Muskeln, die dieses Training beansprucht hat`)
};

const it_it2_workout_highlights_muscles_label = /** @type {(inputs: Workout_Highlights_Muscles_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mappa dei muscoli allenati in questo allenamento`)
};

/**
* | output |
* | --- |
* | "Map of the muscles this workout worked" |
*
* @param {Workout_Highlights_Muscles_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_muscles_label = /** @type {((inputs?: Workout_Highlights_Muscles_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Muscles_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_muscles_label(inputs)
	if (locale === "es-419") return es_419_workout_highlights_muscles_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_muscles_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_muscles_label(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_muscles_label(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_muscles_label(inputs)
	return en_us2_workout_highlights_muscles_label(inputs)
});
export { workout_highlights_muscles_label as "workout-highlights.muscles_label" }